import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import './ConsentPage.css';
import SharkHeader from '../components/SharkHeader';
import { readStoredLinkingProvider } from '../utils/linkingProvider';
import { getCancelRedirectBase } from '../config/voiceLogin';

const CONSENT_COPY = {
  alexa: {
    title: 'Connect with Alexa',
    subtitle: 'Review permissions before linking your SharkClean account.',
    description: 'By choosing Allow, you permit the SharkClean Alexa skill to:',
    permissions: ['Access your SharkClean account to control and monitor eligible devices.'],
    note: 'You can unlink this account anytime from the Alexa app.',
    showGooglePrivacyLink: false,
  },
  google: {
    title: 'Connect with Google Home',
    subtitle: 'Review permissions before linking your SharkClean account.',
    description: 'By choosing Allow, you permit the SharkClean Google Home service to:',
    permissions: ['Access your SharkClean account to control and monitor eligible devices.'],
    note: 'You can unlink this account anytime from the Google Home app.',
    showGooglePrivacyLink: true,
  },
};

const ConsentPage = () => {
  const { search } = useLocation();
  const provider = useMemo(() => readStoredLinkingProvider(search), [search]);
  const copy = CONSENT_COPY[provider] || CONSENT_COPY.alexa;

  const handleAllow = () => {
    const redirectURI = sessionStorage.getItem('redirectURI');
    if (!redirectURI) {
      return;
    }

    window.location.href = redirectURI;
  };

  const handleCancel = () => {
    const queryParams =
      window.location.search || sessionStorage.getItem('voiceLoginReturnSearch') || '';
    const base = getCancelRedirectBase();
    window.location.href = queryParams ? `${base}${queryParams}` : base;
  };

  return (
    <div className="consent-shell">
      <div className="consent-container">
        <SharkHeader />
        <h1 className="consent-title">{copy.title}</h1>
        <p className="consent-subtitle">{copy.subtitle}</p>

        <div className="consent-card">
          <p className="consent-description">{copy.description}</p>
          <ul className="consent-permissions">
            {copy.permissions.map((line) => (
              <li key={line}>{line}</li>
            ))}
          </ul>

          <div className="consent-note">{copy.note}</div>

          {copy.showGooglePrivacyLink ? (
            <p className="consent-policy-link">
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Review Google&apos;s Privacy Policy
              </a>
            </p>
          ) : null}

          <div className="consent-buttons">
            <button type="button" className="consent-allow" onClick={handleAllow}>
              Allow
            </button>
            <button type="button" className="consent-cancel" onClick={handleCancel}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentPage;
